/* 🤖 this file was generated by svg-to-ts */
export const matIconBorderOuter: {
  name: 'border-outer';
  data: string;
} = {
  name: 'border-outer',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z"/></svg>`
};
